import * as React from 'react'
import { IconButtonSeeker, useToaster } from 'ui-seeker/core'

import { useReports } from '../../hooks'
import {REPORT_STATUS} from "../../../../@common/constants";


export default function IconExecuteReports({ idLineSelected, idRowSelected, selectedData, setLoadingStatus }) {

    const { showToaster } = useToaster()
    const { performReports } = useReports()

    const isReadyToPerform = (report) => {
        const isRunning = report?.statusLastExecution === REPORT_STATUS.RUNNING
        const isPreparing = report?.statusLastExecution === REPORT_STATUS.PREPARING
        const isGenerating = [
            report?.csvGenerationStatus,
            report?.xlsGenerationStatus,
            report?.jsonGenerationStatus
        ].some(status => [REPORT_STATUS.NEW, REPORT_STATUS.GENERATING].includes(status));

        return report?.enabled &&
            !isRunning &&
            !isPreparing &&
            !isGenerating
    }
    const showExecBtn = selectedData.every(isReadyToPerform)

	const handleClick = () => {
        showToaster.confirm(`Are you sure to perform all selected reports?`, {
            onSuccess: () => {
                performReports(idLineSelected, idRowSelected, selectedData, setLoadingStatus)
            }
        })
	}

	return showExecBtn ? <IconButtonSeeker icon="play-circle" tooltipPosition="top-right" iconType="fontAwesome" title="Perform reports" onClick={handleClick} /> : <></>
}